import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import Layout from './components/Layout';
import Login from './auth/LogIn';
import Products from './pages/products/Products';
import Supplier from './pages/products/Supplier';
import Categories from './pages/products/Categories';
import History from './pages/orders/History';
import Customer from './pages/orders/Customer';
import Inventory from './pages/products/Inventory';
import Users from './pages/settings/Users';
import Pos from './pages/orders/Pos';
import CustomerLoans from './pages/loans/CustomerLoans';
import Expense from './pages/expenses/Expense';
import NotFoundPage from './pages/NotFoundPage';
import Dashboard from './pages/Dashboard';
import Company from './pages/settings/Company';
import Permission from './pages/settings/Permission';
import StoreLoans from './pages/loans/StoreLoans';
import SystemLogs from './pages/settings/SystemLogs';
import CustomerLoanPayments from './pages/payments/CustomerLoanPayments';
import authService from './apiServices/authService';
import StoreLoanPayments from './pages/payments/StoreLoanPayments';
import Units from './pages/products/Units';
import Database from './pages/settings/Database';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
            light: '#222831',
        },
        secondary: {
            main: '#2e7d32',
        },
        success: {
            light: '#4caf50',
            main: '#2e7d32',
            contrastText: '#fff',
        },
        text: {
            secondary: '#2e7d32',
        },
        info: {
            light: '#2196f3',
            main: '#1976d2',
            contrastText: '#fff',
        },
        action:{ 
            main:'#45046A',
            secondary:'#FF6500'
            },
        background: {
            default: '#f5f5f5',
            paper: '#fff'
        },
    },
});

// Protected Route component
const ProtectedRoute = ({ children }) => {
    if (!authService.isAuthenticated()) {
        return <Navigate to="/" replace />;
    }
    return children;
};

function App() {
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Router>
                    <Routes>
                        {/* Public Route */}
                        <Route path="/" element={<Login />} />

                        {/* Protected Routes sharing the Layout */}
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/categories" element={<Categories />} />
                            <Route path="/suppliers" element={<Supplier />} />
                            <Route path="/pos" element={<Pos />} />
                            <Route path="/history" element={<History />} />
                            <Route path="/units" element={<Units />} />
                            <Route path="/customer" element={<Customer />} />
                            <Route path="/system-logs" element={<SystemLogs />} />
                            <Route path="/customer-loans" element={<CustomerLoans />} />
                            <Route path="/customer-loans-payments" element={<CustomerLoanPayments />} />
                            <Route path="/store-loans-payments" element={<StoreLoanPayments />} />
                            <Route path="/store-loans" element={<StoreLoans />} />
                            <Route path="/expense" element={<Expense />} />
                            <Route path="/company" element={<Company />} />
                            <Route path="/database" element={<Database />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/permission" element={<Permission />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>

                        {/* Fallback Route */}
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </SnackbarProvider>
    );
}

export default App;